import { Core4MetricAverage } from '../../../model/Entities';
import {
    softballCore4Age1012,
    softballCore4Age1314,
    softballCore4Age1516,
    softballCore4Age1718,
    softballCore4Age89,
    softballCore4AgeCollege,
    softballCore4AgePro,
} from './PlayerCore4SoftballAges';
import {
    softballCore4Metric10YD,
    softballCore4Metric20YD,
    softballCore4Metric5105,
    softballCore4MetricBatSpeed,
    softballCore4MetricExitVelocity,
    softballCore4MetricHandGripLT,
    softballCore4MetricHandGripRT,
    softballCore4MetricPeakHandSpeed,
    softballCore4MetricPositionThrowVelocity,
    softballCore4MetricTimeToContact,
    softballCore4MetricVerticalJump,
} from './PlayerCore4SoftballMetrics';

export const softballCore4Averages: Core4MetricAverage[] = [
    // HITTING
    { age: softballCore4Age89, metric: softballCore4MetricExitVelocity, gender: 'Female', average: 45 },
    { age: softballCore4Age89, metric: softballCore4MetricBatSpeed, gender: 'Female', average: 38 },
    { age: softballCore4Age89, metric: softballCore4MetricPeakHandSpeed, gender: 'Female', average: 14 },
    { age: softballCore4Age89, metric: softballCore4MetricTimeToContact, gender: 'Female', average: 0.2 },

    { age: softballCore4Age1012, metric: softballCore4MetricExitVelocity, gender: 'Female', average: 49.5 },
    { age: softballCore4Age1012, metric: softballCore4MetricBatSpeed, gender: 'Female', average: 40 },
    { age: softballCore4Age1012, metric: softballCore4MetricPeakHandSpeed, gender: 'Female', average: 15 },
    { age: softballCore4Age1012, metric: softballCore4MetricTimeToContact, gender: 'Female', average: 0.2 },

    { age: softballCore4Age1314, metric: softballCore4MetricExitVelocity, gender: 'Female', average: 58.5 },
    { age: softballCore4Age1314, metric: softballCore4MetricBatSpeed, gender: 'Female', average: 48.5 },
    { age: softballCore4Age1314, metric: softballCore4MetricPeakHandSpeed, gender: 'Female', average: 16.5 },
    { age: softballCore4Age1314, metric: softballCore4MetricTimeToContact, gender: 'Female', average: 0.19 },

    { age: softballCore4Age1516, metric: softballCore4MetricExitVelocity, gender: 'Female', average: 66.5 },
    { age: softballCore4Age1516, metric: softballCore4MetricBatSpeed, gender: 'Female', average: 57.5 },
    { age: softballCore4Age1516, metric: softballCore4MetricPeakHandSpeed, gender: 'Female', average: 18 },
    { age: softballCore4Age1516, metric: softballCore4MetricTimeToContact, gender: 'Female', average: 0.18 },

    { age: softballCore4Age1718, metric: softballCore4MetricExitVelocity, gender: 'Female', average: 73 },
    { age: softballCore4Age1718, metric: softballCore4MetricBatSpeed, gender: 'Female', average: 65 },
    { age: softballCore4Age1718, metric: softballCore4MetricPeakHandSpeed, gender: 'Female', average: 19 },
    { age: softballCore4Age1718, metric: softballCore4MetricTimeToContact, gender: 'Female', average: 0.17 },

    { age: softballCore4AgeCollege, metric: softballCore4MetricExitVelocity, gender: 'Female', average: 75 },
    { age: softballCore4AgeCollege, metric: softballCore4MetricBatSpeed, gender: 'Female', average: 70 },
    { age: softballCore4AgeCollege, metric: softballCore4MetricPeakHandSpeed, gender: 'Female', average: 20 },
    { age: softballCore4AgeCollege, metric: softballCore4MetricTimeToContact, gender: 'Female', average: 0.16 },

    { age: softballCore4AgePro, metric: softballCore4MetricExitVelocity, gender: 'Female', average: 80 },
    { age: softballCore4AgePro, metric: softballCore4MetricBatSpeed, gender: 'Female', average: 75 },
    { age: softballCore4AgePro, metric: softballCore4MetricPeakHandSpeed, gender: 'Female', average: 22 },
    { age: softballCore4AgePro, metric: softballCore4MetricTimeToContact, gender: 'Female', average: 0.14 },

    // ARM VELOCITY

    { age: softballCore4Age89, metric: softballCore4MetricPositionThrowVelocity, gender: 'Female', average: 35 },

    { age: softballCore4Age1012, metric: softballCore4MetricPositionThrowVelocity, gender: 'Female', average: 40 },

    { age: softballCore4Age1314, metric: softballCore4MetricPositionThrowVelocity, gender: 'Female', average: 46 },

    { age: softballCore4Age1516, metric: softballCore4MetricPositionThrowVelocity, gender: 'Female', average: 54 },

    { age: softballCore4Age1718, metric: softballCore4MetricPositionThrowVelocity, gender: 'Female', average: 57 },

    { age: softballCore4AgeCollege, metric: softballCore4MetricPositionThrowVelocity, gender: 'Female', average: 60 },

    { age: softballCore4AgePro, metric: softballCore4MetricPositionThrowVelocity, gender: 'Female', average: 65 },

    // SPEED & AGILITY

    { age: softballCore4Age89, metric: softballCore4Metric10YD, gender: 'Female', average: 2.1 },
    { age: softballCore4Age89, metric: softballCore4Metric20YD, gender: 'Female', average: 3.7 },
    { age: softballCore4Age89, metric: softballCore4Metric5105, gender: 'Female', average: 5.9 },

    { age: softballCore4Age1012, metric: softballCore4Metric10YD, gender: 'Female', average: 1.95 },
    { age: softballCore4Age1012, metric: softballCore4Metric20YD, gender: 'Female', average: 3.4 },
    { age: softballCore4Age1012, metric: softballCore4Metric5105, gender: 'Female', average: 5.5 },

    { age: softballCore4Age1314, metric: softballCore4Metric10YD, gender: 'Female', average: 1.8 },
    { age: softballCore4Age1314, metric: softballCore4Metric20YD, gender: 'Female', average: 3.2 },
    { age: softballCore4Age1314, metric: softballCore4Metric5105, gender: 'Female', average: 5.25 },

    { age: softballCore4Age1516, metric: softballCore4Metric10YD, gender: 'Female', average: 1.75 },
    { age: softballCore4Age1516, metric: softballCore4Metric20YD, gender: 'Female', average: 3.05 },
    { age: softballCore4Age1516, metric: softballCore4Metric5105, gender: 'Female', average: 5.1 },

    { age: softballCore4Age1718, metric: softballCore4Metric10YD, gender: 'Female', average: 1.7 },
    { age: softballCore4Age1718, metric: softballCore4Metric20YD, gender: 'Female', average: 2.95 },
    { age: softballCore4Age1718, metric: softballCore4Metric5105, gender: 'Female', average: 4.95 },

    { age: softballCore4AgeCollege, metric: softballCore4Metric10YD, gender: 'Female', average: 1.6 },
    { age: softballCore4AgeCollege, metric: softballCore4Metric20YD, gender: 'Female', average: 2.85 },
    { age: softballCore4AgeCollege, metric: softballCore4Metric5105, gender: 'Female', average: 4.8 },

    { age: softballCore4AgePro, metric: softballCore4Metric10YD, gender: 'Female', average: 1.55 },
    { age: softballCore4AgePro, metric: softballCore4Metric20YD, gender: 'Female', average: 2.8 },
    { age: softballCore4AgePro, metric: softballCore4Metric5105, gender: 'Female', average: 4.7 },

    // STRENGTH

    { age: softballCore4Age89, metric: softballCore4MetricVerticalJump, gender: 'Female', average: 12 },
    { age: softballCore4Age89, metric: softballCore4MetricHandGripRT, gender: 'Female', average: 40 },
    { age: softballCore4Age89, metric: softballCore4MetricHandGripLT, gender: 'Female', average: 40 },

    { age: softballCore4Age1012, metric: softballCore4MetricVerticalJump, gender: 'Female', average: 14 },
    { age: softballCore4Age1012, metric: softballCore4MetricHandGripRT, gender: 'Female', average: 45 },
    { age: softballCore4Age1012, metric: softballCore4MetricHandGripLT, gender: 'Female', average: 45 },

    { age: softballCore4Age1314, metric: softballCore4MetricVerticalJump, gender: 'Female', average: 16 },
    { age: softballCore4Age1314, metric: softballCore4MetricHandGripRT, gender: 'Female', average: 57 },
    { age: softballCore4Age1314, metric: softballCore4MetricHandGripLT, gender: 'Female', average: 57 },

    { age: softballCore4Age1516, metric: softballCore4MetricVerticalJump, gender: 'Female', average: 17 },
    { age: softballCore4Age1516, metric: softballCore4MetricHandGripRT, gender: 'Female', average: 70 },
    { age: softballCore4Age1516, metric: softballCore4MetricHandGripLT, gender: 'Female', average: 70 },

    { age: softballCore4Age1718, metric: softballCore4MetricVerticalJump, gender: 'Female', average: 20 },
    { age: softballCore4Age1718, metric: softballCore4MetricHandGripRT, gender: 'Female', average: 80 },
    { age: softballCore4Age1718, metric: softballCore4MetricHandGripLT, gender: 'Female', average: 80 },

    { age: softballCore4AgeCollege, metric: softballCore4MetricVerticalJump, gender: 'Female', average: 24 },
    { age: softballCore4AgeCollege, metric: softballCore4MetricHandGripRT, gender: 'Female', average: 90 },
    { age: softballCore4AgeCollege, metric: softballCore4MetricHandGripLT, gender: 'Female', average: 90 },

    { age: softballCore4AgePro, metric: softballCore4MetricVerticalJump, gender: 'Female', average: 26 },
    { age: softballCore4AgePro, metric: softballCore4MetricHandGripRT, gender: 'Female', average: 95 },
    { age: softballCore4AgePro, metric: softballCore4MetricHandGripLT, gender: 'Female', average: 95 },
];
